import { render, staticRenderFns } from "./SafetyContentEditor.vue?vue&type=template&id=0f58250e&scoped=true&"
import script from "./SafetyContentEditor.vue?vue&type=script&lang=js&"
export * from "./SafetyContentEditor.vue?vue&type=script&lang=js&"
import style0 from "./SafetyContentEditor.vue?vue&type=style&index=0&id=0f58250e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f58250e",
  null
  
)

export default component.exports